
// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import "../assets/css/CollectionReport.css";
// import { useNavigate } from "react-router-dom";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";  // default import
// const GroupCollectionReport = () => {
//   const [collections, setCollections] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filters, setFilters] = useState({
//     memberId: "",
//     centreName: "",
//     status: "",
//     paidDate: "",
//   });

//   // ✅ Fetch collection data on mount
//   useEffect(() => {
//     const fetchCollections = async () => {
//       try {
      
//         const response = await fetch(
//           `https://narrowitsolution.in/api/group-loan/ledger-transaction-report?branchId=${localStorage.getItem("userId")}`
//         );
//         const data = await response.json();
//         // if (data.success && Array.isArray(data.collections)) {
//         //   setCollections(data.collections);
//         // } else {
//         //   console.warn("Unexpected API response:", data);
//         // }
//         if (data.success && Array.isArray(data.data)) {
//   setCollections(data.data);
// } else {
//   console.warn("Unexpected API response:", data);
// }
//       } catch (error) {
//         console.error("Error fetching collection report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCollections();
//   }, []);

//   // ✅ Handle filter changes
//   const handleFilterChange = (field, value) => {
//     setFilters((prev) => ({ ...prev, [field]: value }));
//   };

//   // ✅ Filter collections
//   const filteredCollections = collections.filter((col) => {
//     const memberMatch =
//       !filters.memberId ||
//       col.memberId?.toString().toLowerCase().includes(filters.memberId.toLowerCase());
//     const centreMatch =
//       !filters.centreName ||
//       col.centreName?.toLowerCase().includes(filters.centreName.toLowerCase());
//     const statusMatch =
//       !filters.status || col.status?.toLowerCase() === filters.status.toLowerCase();
//     const dateMatch =
//       !filters.paidDate ||
//       new Date(col.paidDate).toLocaleDateString("en-CA") === filters.paidDate;

//     return memberMatch && centreMatch && statusMatch && dateMatch;
//   });

//   if (loading) {
//     return <p>Loading collection report...</p>;
//   }






// // 🔹 Export CSV
// const exportCSV = () => {
//   const csvRows = [
//     ["#", "Member ID", "Centre", "Loan ID", "Paid Amount", "Paid Date", "Status"],
//     ...filteredCollections.map((col, i) => [
//       i + 1,
//       col.memberId || "-",
//       col.centreName || "-",
//       col.groupLoanId || "-",
//       col.total || "-",
//       col.paidAt ? new Date(col.paidAt).toLocaleDateString() : "-",
//       "Paid",
//     ]),
//   ];
//   const csvContent = csvRows.map((r) => r.join(",")).join("\n");
//   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//   saveAs(blob, "collection_report.csv");
// };

// // 🔹 Export Excel
// const exportExcel = () => {
//   const ws = XLSX.utils.json_to_sheet(
//     filteredCollections.map((col, i) => ({
//       SrNo: i + 1,
//       "Member ID": col.memberId || "-",
//       Centre: col.centreName || "-",
//       "Loan ID": col.groupLoanId || "-",
//       "Paid Amount": col.total || "-",
//       "Paid Date": col.paidAt ? new Date(col.paidAt).toLocaleDateString() : "-",
//       Status: "Paid",
//     }))
//   );
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Collection Report");
//   XLSX.writeFile(wb, "collection_report.xlsx");
// };

// // // 🔹 Export PDF
// // const exportPDF = () => {
// //   const doc = new jsPDF();
// //   doc.text("Collection Report", 14, 15);
// //   doc.autoTable({
// //     head: [["#", "Member ID", "Centre", "Loan ID", "Paid Amount", "Paid Date", "Status"]],
// //     body: filteredCollections.map((col, i) => [
// //       i + 1,
// //       col.memberId || "-",
// //       col.centreName || "-",
// //       col.groupLoanId || "-",
// //       col.total || "-",
// //       col.paidAt ? new Date(col.paidAt).toLocaleDateString() : "-",
// //       "Paid",
// //     ]),
// //   });
// //   doc.save("collection_report.pdf");
// // };

// // 🔹 Export PDF
// const exportPDF = () => {
//   const doc = new jsPDF();
//   doc.text("Collection Report", 14, 15);

//   autoTable(doc, {
//     head: [["#", "Member ID", "Centre", "Loan ID", "Paid Amount", "Paid Date", "Status"]],
//     body: filteredCollections.map((col, i) => [
//       i + 1,
//       col.memberId || "-",
//       col.centreName || "-",
//       col.groupLoanId || "-",
//       col.total || "-",
//       col.paidAt ? new Date(col.paidAt).toLocaleDateString() : "-",
//       "Paid",
//     ]),
//     startY: 25, // 👈 leaves space for the title
//   });

//   doc.save("collection_report.pdf");
// };
//   return (
//     <div className="collectionReportApp">
//       <h2 className="reportTitle">Collection Report</h2>

//       {/* 🔍 Filter Section */}
//       <div className="filterSection">
//         <input
//           type="text"
//           placeholder="Filter by Member ID"
//           value={filters.memberId}
//           onChange={(e) => handleFilterChange("memberId", e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Filter by Centre"
//           value={filters.centreName}
//           onChange={(e) => handleFilterChange("centreName", e.target.value)}
//         />
       
//         {/* <input
//           type="date"
//           value={filters.paidDate}
//           onChange={(e) => handleFilterChange("paidDate", e.target.value)}
//         /> */}
//       </div>



// {/* Export Buttons */}
// {filteredCollections.length > 0 && (
//   <div className="exportButtons" style={{ marginBottom: "15px", textAlign: "right" }}>
//     <button onClick={exportCSV} className="btnExport">Export CSV</button>
//     <button onClick={exportExcel} className="btnExport">Export Excel</button>
//     <button onClick={exportPDF} className="btnExport">Export PDF</button>
//   </div>
// )}

//       {/* 💻 Desktop Table */}
//       <div className="tableWrapper desktopOnly">
//         <table className="collectionDetailsTable">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Member ID</th>
//               <th>Centre</th>
//               <th>Loan ID</th>
//               {/* <th>EMI No.</th> */}
//               <th>Paid Amount</th>
//               <th>Paid Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredCollections.length > 0 ? (
//               filteredCollections.map((col, index) => (
//                 <tr key={col.id}>
//                   <td>{index + 1}</td>
//                   <td>{col.memberId}</td>
//                   <td>{col.centreName}</td>
//                   <td>{col.groupLoanId}</td>
//                   {/* <td>{col.emiNo}</td> */}
//                   <td>₹{col.total}</td>
//                   <td>{new Date(col.paidAt).toLocaleDateString()}</td>
//                   <td >
//                  Paid
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={8} style={{ textAlign: "center" }}>
//                   No collections found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* 📱 Mobile Card Layout */}
//       <div className="mobileOnly">
//         {filteredCollections.length > 0 ? (
//           filteredCollections.map((col) => (
//             <div key={col.id} className="collectionCard">
//               <p><strong>Member:</strong> {col.memberId}</p>
//               <p><strong>Centre:</strong> {col.centreName}</p>
//               <p><strong>Loan ID:</strong> {col.loanId}</p>
//               <p><strong>EMI No.:</strong> {col.emiNo}</p>
//               <p><strong>Paid:</strong> ₹{col.paidAmount}</p>
//               <p><strong>Date:</strong> {new Date(col.paidDate).toLocaleDateString()}</p>
//               <p>
//                 <strong>Status:</strong>{" "}
//                 <span className={col.status === "paid" ? "statusPaid" : "statusPending"}>
//                   {col.status}
//                 </span>
//               </p>
//             </div>
//           ))
//         ) : (
//           <p>No collections found.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GroupCollectionReport;
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../assets/css/CollectionReport.css";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const GroupCollectionReport = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    memberId: "",
    centreName: "",
    status: "",
    transactionDate: "",
  });

  // Fetch collection data on mount
  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const response = await fetch(
          `https://narrowitsolution.in/api/group-loan/ledger-transaction-report?branchId=${localStorage.getItem("userId")}`
        );
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          setCollections(data.data);
        } else {
          console.warn("Unexpected API response:", data);
        }
      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCollections();
  }, []);

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  // Filter collections
  const filteredCollections = collections.filter((col) => {
    const memberMatch =
      !filters.memberId ||
      col.memberId?.toLowerCase().includes(filters.memberId.toLowerCase());
    const centreMatch =
      !filters.centreName ||
      (col.centreName?.toLowerCase() || "").includes(filters.centreName.toLowerCase());
    const statusMatch =
      !filters.status || col.status?.toLowerCase() === filters.status.toLowerCase();
    const dateMatch =
      !filters.transactionDate ||
      new Date(col.transactionDate).toLocaleDateString("en-CA") === filters.transactionDate;

    return memberMatch && centreMatch && statusMatch && dateMatch;
  });

  if (loading) {
    return <p>Loading collection report...</p>;
  }

  // Export CSV
  const exportCSV = () => {
    const csvRows = [
      ["#", "Member ID", "Type", "Loan ID", "Paid Amount", "Transaction Date", "Status"],
      ...filteredCollections.map((col, i) => [
        i + 1,
        col.memberId || "-",
        col.type || "-",
        col.referenceId || "-",
        col.amount || "-",
        col.transactionDate ? new Date(col.transactionDate).toLocaleDateString() : "-",
        col.status || "-",
      ]),
    ];
    const csvContent = csvRows.map((r) => r.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "collection_report.csv");
  };

  // Export Excel
  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      filteredCollections.map((col, i) => ({
        SrNo: i + 1,
        "Member ID": col.memberId || "-",
        "Type": col.type || "-",
        "Loan ID": col.referenceId || "-",
        "Paid Amount": col.amount || "-",
        "Transaction Date": col.transactionDate
          ? new Date(col.transactionDate).toLocaleDateString()
          : "-",
        Status: col.status || "-",
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Collection Report");
    XLSX.writeFile(wb, "collection_report.xlsx");
  };

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Collection Report", 14, 15);
    autoTable(doc, {
      head: [["#", "Member ID", "Type", "Loan ID", "Paid Amount", "Transaction Date", "Status"]],
      body: filteredCollections.map((col, i) => [
        i + 1,
        col.memberId || "-",
        col.type || "-",
        col.referenceId || "-",
        col.amount || "-",
        col.transactionDate ? new Date(col.transactionDate).toLocaleDateString() : "-",
        col.status || "-",
      ]),
      startY: 25,
    });
    doc.save("collection_report.pdf");
  };

  return (
    <div className="collectionReportApp">
      <h2 className="reportTitle">Collection Report</h2>

      {/* Filter Section */}
      <div className="filterSection">
        <input
          type="text"
          placeholder="Filter by Member ID"
          value={filters.memberId}
          onChange={(e) => handleFilterChange("memberId", e.target.value)}
        />
       
        <input
          type="date"
          value={filters.transactionDate}
          onChange={(e) => handleFilterChange("transactionDate", e.target.value)}
        />
      </div>

      {/* Export Buttons */}
      {filteredCollections.length > 0 && (
        <div className="exportButtons" style={{ marginBottom: "15px", textAlign: "right" }}>
          <button onClick={exportCSV} className="btnExport">Export CSV</button>
          <button onClick={exportExcel} className="btnExport">Export Excel</button>
          <button onClick={exportPDF} className="btnExport">Export PDF</button>
        </div>
      )}

      {/* Desktop Table */}
      <div className="tableWrapper desktopOnly">
        <table className="collectionDetailsTable">
          <thead>
            <tr>
              <th>#</th>
              <th>Member/Branch ID</th>
              <th>Type</th>
              <th>Loan ID</th>
              <th>Paid Amount</th>
              <th>Transaction Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredCollections.length > 0 ? (
              filteredCollections.map((col, index) => (
                <tr key={col.id}>
                  <td>{index + 1}</td>
                  <td>{col.memberId || col.branchId}</td>
                  <td>{col.type || "-"}</td>
                  <td>{col.referenceId}</td>
                  <td>₹{col.amount}</td>
                  <td>{new Date(col.transactionDate).toLocaleDateString()}</td>
                  <td>{col.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  No collections found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile Card Layout */}
      <div className="mobileOnly">
        {filteredCollections.length > 0 ? (
          filteredCollections.map((col) => (
            <div key={col.id} className="collectionCard">
              <p><strong>Member:</strong> {col.memberId}</p>
              <p><strong>Centre:</strong> {col.centreName || "-"}</p>
              <p><strong>Loan ID:</strong> {col.referenceId}</p>
              <p><strong>Paid:</strong> ₹{col.amount}</p>
              <p><strong>Date:</strong> {new Date(col.transactionDate).toLocaleDateString()}</p>
              <p><strong>Status:</strong> <span className={col.status === "COMPLETED" ? "statusPaid" : "statusPending"}>{col.status}</span></p>
            </div>
          ))
        ) : (
          <p>No collections found.</p>
        )}
      </div>
    </div>
  );
};

export default GroupCollectionReport;
